var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.582 31.636V32.136H90.082H105.982C111.555 32.136 116.082 36.6364 116.082 42.1623V57.4517H11.082V42.1623C11.082 36.6364 15.609 32.136 21.182 32.136H37.082H37.582V31.636V21.1096C37.582 15.5838 42.109 11.0833 47.682 11.0833H79.482C85.0551 11.0833 89.582 15.5838 89.582 21.1096V31.636ZM47.682 20.6096H47.182V21.1096V31.636V32.136H47.682H79.482H79.982V31.636V21.1096V20.6096H79.482H47.682ZM74.182 74.2412H74.682V73.7412V63.7149H116.082V100.057C116.082 105.583 111.555 110.083 105.982 110.083H21.182C15.609 110.083 11.082 105.583 11.082 100.057V63.7149H52.482V73.7412V74.2412H52.982H74.182Z",
    stroke: "#5f9098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/Briefcase.334db86755a81801dd2045080a99fcee.svg";
export { ForwardRef as ReactComponent };